var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"switch"},[_c('i',{staticClass:"far fa-toggle-on",class:{ rotated: !_vm.value, disabled: _vm.disabled },on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }